export const JOB_INVITE_SUBMIT_REQUEST = 'job/invite-submit-request'
export const JOB_INVITE_SUBMIT_SUCCESS = 'job/invite-submit-success'
export const JOB_INVITE_SUBMIT_FAILED = 'job/invite-submit-failed'
